/**
 * Functionality related to the monaco editor.
 * https://microsoft.github.io/monaco-editor/
 */

export { createSnippetCompletionProvider } from "./Autocomplete.ts";
export { registerJsonSchema, registerJsonSchemas } from "./JsonSchema.ts";
export { createExtender } from "./MonacoExtender.ts";
export { getSnippets, registerSnippetLib } from "./Snippets.ts";
export { getDefaultTypes } from "./TypeDefinitions.ts";
